import React from 'react';

import { useTranslation } from 'react-i18next';

import { Badge } from '@pkg/components/Sections/Profile/Badge';

import { SelectedCopy, SelectedWrapper } from './styles';

export interface SelectedProps {
    count?: number;
    handleToggleSelectAllItems?: () => void;
    selectedAllItems?: boolean;
}

export function Selected({ count = 0, handleToggleSelectAllItems, selectedAllItems }: SelectedProps) {
    // TODO: The translation source should not be tied to `yat_nft_manager`.
    const { t: translate } = useTranslation(['yat_nft_manager']);

    const copy = handleToggleSelectAllItems
        ? selectedAllItems
            ? translate('yat_nft_manager_unselect_all')
            : translate('yat_nft_manager_select_all')
        : translate('yat_nft_manager_selected');

    return (
        <SelectedWrapper>
            <Badge color="primary" variant="round">
                {count}
            </Badge>

            <SelectedCopy $canToggle={!!handleToggleSelectAllItems} onClick={handleToggleSelectAllItems}>
                {copy}
            </SelectedCopy>
        </SelectedWrapper>
    );
}
